import { ErrorCatcher } from 'components/Error/Catcher'

function ErrorBoundary({ data, error, retry, children }) {
  return (
    <ErrorCatcher data={data} error={error} retry={retry}>
      <Check data={data} error={error}>
        {children}
      </Check>
    </ErrorCatcher>
  )
}

function Check({ data, error, children }) {
  if (!data && !!error) throw new Error(error)
  return children
}

export default ErrorBoundary
